import React from 'react';
import { Button, Card, Select } from 'antd';

const { Option } = Select;

export default function OrderAssignmentBar(props) {
    const { order, assigneeOptions = [], canAssign, canReassign, selectedAssigneeId, onAssigneeChange, onAssign, onReassign } = props;

    return (
        <Card title="Phân công xử lý">
            <div style={{ marginBottom: 12 }}>
                <strong>Hiện tại:</strong> {order.assignee && order.assignee.name ? order.assignee.name : 'Chưa assign'}
            </div>
            {(canAssign || canReassign) ? (
                <div className="d-flex" style={{ gap: 8 }}>
                    <Select style={{ width: 240 }} value={selectedAssigneeId} onChange={onAssigneeChange}>
                        {assigneeOptions.map((item) => <Option key={item.user_id} value={item.user_id}>{item.name}</Option>)}
                    </Select>
                    {canAssign ? <Button onClick={onAssign}>Nhận xử lý</Button> : null}
                    {canReassign ? <Button onClick={onReassign}>Phân công lại</Button> : null}
                </div>
            ) : (
                <div>Read-only</div>
            )}
        </Card>
    );
}
